import { render, staticRenderFns } from "./vitalitys.vue?vue&type=template&id=fdddb1b2"
import script from "./vitalitys.vue?vue&type=script&lang=js"
export * from "./vitalitys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports